import React from "react";
import { Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";

import AssistantGuideList from "../guide-list";
import AssistantClarificationChoices from "../clarification-choices";
import AssistantMarkdown from "./components/markdown";
import {
  AssistantRelatedTopic,
  AssistantRelatedTopicContent,
  AssistantRelatedTopics,
  AssistantRelatedTopicSummary,
} from "./styles";
import { IAssistantAnswerSectionProps } from "./types";

const AssistantAnswerSection: React.FC<IAssistantAnswerSectionProps> = ({
  answer,
  pending,
  onChoose,
}) => {
  return (
    <>
      <AssistantMarkdown>{answer.answer}</AssistantMarkdown>
      {Boolean(answer.choices?.length) && (
        <AssistantClarificationChoices
          choices={answer.choices}
          pending={pending}
          onChoose={onChoose}
        />
      )}
      {answer.sources.length > 0 && (
        <AssistantRelatedTopics aria-label="Related topics">
          <Typography variant="subtitle8" component="h3">
            Related topics
          </Typography>
          {answer.sources.map((source) => (
            <AssistantRelatedTopic key={source.id}>
              <AssistantRelatedTopicSummary>
                <MenuBookOutlinedIcon fontSize="small" />
                <Typography variant="subtitle9" component="span">
                  {source.title}
                </Typography>
                <ChevronRightIcon fontSize="small" />
              </AssistantRelatedTopicSummary>
              <AssistantRelatedTopicContent>
                <AssistantMarkdown>{source.text}</AssistantMarkdown>
                {Boolean(source.guides?.length) && (
                  <AssistantGuideList
                    guides={source.guides ?? []}
                    showHeading={false}
                  />
                )}
              </AssistantRelatedTopicContent>
            </AssistantRelatedTopic>
          ))}
        </AssistantRelatedTopics>
      )}
    </>
  );
};

export default AssistantAnswerSection;
